import React, { useContext, useState } from "react";
import {
  Stack,
  Button,
  useMediaQuery,
  Grid,
  Box,
  Divider,
  Typography,
} from "@mui/material";

import overview from "./assets/overview.svg";
import d2 from "./assets/d2.svg";
import { AppContext, gasEstimationForAll } from "../../utils";
import { ToastNotify, useMainnodeContract } from "../../ConnectivityAss/hooks";
import Loading from "../../loading";

//table
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";


// Timer
import Timer from '../Timer'

function Overview({ totalNode1, totalNode2, totalNode3, userNodesData, init,ConValue }) {
  const [jackPots, setjackPots] = useState(0);
  const [CON, setCON] = useState(0);
  const mobile = useMediaQuery("(max-width:1050px)");
  const { account, signer, connect } = useContext(AppContext);
  const [loading, setloading] = useState(false);

  const [alertState, setAlertState] = useState({
    open: false,
    message: "",
    severity: undefined,
  });
  const mainNodeContract = useMainnodeContract(signer);

  const claimHandler = async (nodeIndex) => {
    try {
      setloading(true);
      let data = [nodeIndex];
      let fn = mainNodeContract.estimateGas.cashoutAll;
      const tx = await mainNodeContract.cashoutAll(...data, {
        gasLimit: gasEstimationForAll(account, fn, data),
      });
      await tx.wait();
      setloading(false);
      await init();
      setAlertState({
        open: true,
        message: `Transaction Successfully completed`,
        severity: "success",
      });
    } catch (error) {
      if (error?.data?.message) {
        setAlertState({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      } else {
        setAlertState({
          open: true,
          message: error?.message,
          severity: "error",
        });
      }
      setloading(false);
    }
  };
  const claimOneHandler = async (time, nodeIndex) => {
    try {
      setloading(true);
      let data = [time.toString(), nodeIndex];
      let fn = mainNodeContract.estimateGas.cashoutReward;
      const tx = await mainNodeContract.cashoutReward(...data, {
        gasLimit: gasEstimationForAll(account, fn, data),
      });
      await tx.wait();
      setloading(false);
      await init();
      setAlertState({
        open: true,
        message: `Transaction Successfully completed`,
        severity: "success",
      });
    } catch (error) {
      if (error?.data?.message) {
        setAlertState({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      } else {
        setAlertState({
          open: true,
          message: error?.message,
          severity: "error",
        });
      }
      setloading(false);
    }
  };
  const compoundHandler = async (nodeIndex) => {
    try {
      setloading(true);
      let data = [nodeIndex];
      let fn = mainNodeContract.estimateGas.compoundNodeReward;
      const tx = await mainNodeContract.compoundNodeReward(...data, {
        gasLimit: gasEstimationForAll(account, fn, data),
      });
      await tx.wait();
      setloading(false);
      await init();
      setAlertState({
        open: true,
        message: `Transaction Successfully completed`,
        severity: "success",
      });
    } catch (error) {
      if (error?.data?.message) {
        setAlertState({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      } else {
        setAlertState({
          open: true,
          message: error?.message,
          severity: "error",
        });
      }
      setloading(false);
    }
  };
  return (
    <>
      <Box
        mt={mobile ? "50px" : "100px"}
        width="100%"
        sx={{
          fontSize: mobile ? "40px" : "60px",
          fontWeight: "400",
          color: "#DA251D",
          textAlign: "center",
        }}
      >
        <img
          src={overview}
          style={{ maxWidth: "419px", width: "100%" }}
          alt=""
        />
      </Box>
      <ToastNotify alertState={alertState} setAlertState={setAlertState} />
      <Loading loading={loading} />

      <Box
        className="border"
        width="100%"
        px={mobile ? "15px" : "43px"}
        py={mobile ? "20px" : "52px"}
        sx={{
          background: " rgba(248, 248, 248, 0.1)",
          backdropFilter: "blur(10px)",
          borderRadius: "20px",
          zIndex: "1",
          fontFamily: "regular",
        }}
      >
        <TableContainer>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell>
                  {" "}
                  <Box
                    sx={{
                      fontSize: mobile ? "18px" : "30px",
                      fontWeight: "400",
                      color: "#FAA631",
                      // textAlign: "center",
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        fontSize: mobile ? "18px" : "30px",
                        fontWeight: "400",
                        color: "#FAA631",
                        // textAlign: "center",
                        fontFamily: "light",
                      }}
                    >
                      {" "}
                      TOTAL NODES
                    </Box>
                    :{userNodesData?.node1Data?.length + userNodesData?.node2Data?.length + userNodesData?.node3Data?.length}
                  </Box>
                </TableCell>
                <TableCell colSpan={3}>
                  {" "}
                  <Box
                    sx={{
                      fontSize: mobile ? "18px" : "30px",
                      fontWeight: "400",
                      color: "#FAA631",
                      // textAlign: "center",
                      fontFamily: "light",
                    }}
                  >
                    REWARDS
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow

              // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  <Box
                    sx={{
                      fontSize: mobile ? "15px" : "20px",
                      fontWeight: "400",
                      color: "white",
                      // textAlign: "center",
                      fontFamily: "regular",
                    }}
                  >
                    Silver Paltis : {userNodesData?.node1Data?.length}
                  </Box>
                </TableCell>
                <TableCell>
                  <Box
                    sx={{
                      fontSize: mobile ? "15px" : "20px",
                      fontWeight: "400",
                      color: "white",
                      // textAlign: "center",
                      fontFamily: "regular",
                    }}
                  >
                    Silver Paltis :{" "}
                    {(+userNodesData?.totalRewardNode1).toFixed(4)}
                  </Box>
                </TableCell>

                <TableCell>
                  <Button
                    sx={{
                      fontSize: mobile ? "12px" : "25px",
                      backgroundColor: "transparent",
                      "&:hover": {
                        background: "white",
                        color: "#FAA631",
                        border: "black",
                      },
                      color: "white",
                      borderRadius: "10px",
                      border: "solid 1px  #FAA631",
                      height: "43px",
                      paddingX: mobile ? "0px" : "20px",
                      marginX: mobile ? "0px" : "10px",
                      fontFamily: "light",
                    }}
                    onClick={() => claimHandler("0")}
                  >
                    Claim All
                  </Button>
                  <Button
                    sx={{
                      fontSize: mobile ? "12px" : "25px",
                      backgroundColor: "transparent",
                      "&:hover": {
                        background: "white",
                        color: "#FAA631",
                        border: "black",
                      },
                      color: "white",
                      borderRadius: "10px",
                      border: "solid 1px  #FAA631",
                      height: "43px",
                      paddingX: mobile ? "0px" : "20px",
                      fontFamily: "light",
                      marginTop: mobile ? "10px" : "0px",
                    }}
                    onClick={() => {
                      console.log(Number((+userNodesData?.totalRewardNode1).toFixed(4)),"number");
                      console.log(ConValue.con1,"con1");
                      console.log(ConValue.con2,"con2");
                      console.log(ConValue.con3,"con3");
                      if(Number((+userNodesData?.totalRewardNode1).toFixed(4)) < ConValue.con1){
                        setAlertState({
                          open: true,
                          message:`You need Minimum ${ConValue.con1} CON`,
                          severity: "error",
                        });
                      }else{
                        compoundHandler("0")
                      }
                     
                    }}
                  >
                    Compound
                  </Button>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell component="th" scope="row">
                  <Box
                    sx={{
                      fontSize: mobile ? "15px" : "20px",
                      fontWeight: "400",
                      color: "white",
                      // textAlign: "center",
                      fontFamily: "regular",
                    }}
                  >
                    Diamond Lucius : {userNodesData?.node2Data?.length}
                  </Box>
                </TableCell>
                <TableCell>
                  <Box
                    sx={{
                      fontSize: mobile ? "15px" : "20px",
                      fontWeight: "400",
                      color: "white",
                      // textAlign: "center",
                      fontFamily: "regular",
                    }}
                  >
                    Diamond Lucius :{" "}
                    {(+userNodesData?.totalRewardNode2).toFixed(4)}
                  </Box>
                </TableCell>

                <TableCell>
                  <Button
                    sx={{
                      fontSize: mobile ? "12px" : "25px",
                      backgroundColor: "transparent",
                      "&:hover": {
                        background: "white",
                        color: "#FAA631",
                        border: "black",
                      },
                      color: "white",
                      borderRadius: "10px",
                      border: "solid 1px  #FAA631",
                      height: "43px",
                      paddingX: mobile ? "0px" : "20px",
                      marginX: mobile ? "0px" : "10px",

                      fontFamily: "light",
                    }}
                    onClick={() => claimHandler("1")}
                  >
                    Claim All
                  </Button>
                  <Button
                    sx={{
                      fontSize: mobile ? "12px" : "25px",
                      backgroundColor: "transparent",
                      "&:hover": {
                        background: "white",
                        color: "#FAA631",
                        border: "black",
                      },
                      color: "white",
                      borderRadius: "10px",
                      border: "solid 1px  #FAA631",
                      height: "43px",
                      paddingX: mobile ? "0px" : "20px",
                      fontFamily: "light",
                      marginTop: mobile ? "10px" : "0px",
                    }}
                    onClick={() =>{

                      if(Number((+userNodesData?.totalRewardNode1).toFixed(4)) < ConValue.con2){
                        setAlertState({
                          open: true,
                          message:`You need Minimum ${ConValue.con2} CON`,
                          severity: "error",
                        });
                      }else{
                        compoundHandler("1")
                      }

                       
                      }}
                  >
                    Compound
                  </Button>
                </TableCell>
              </TableRow>

              <TableRow

              // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  <Box
                    sx={{
                      fontSize: mobile ? "15px" : "20px",
                      fontWeight: "400",
                      color: "white",
                      // textAlign: "center",
                      fontFamily: "regular",
                    }}
                  >
                    Golden Emis : {userNodesData?.node3Data?.length}
                  </Box>
                </TableCell>
                <TableCell>
                  <Box
                    sx={{
                      fontSize: mobile ? "15px" : "20px",
                      fontWeight: "400",
                      color: "white",
                      // textAlign: "center",
                      fontFamily: "regular",
                    }}
                  >
                    Golden Emis :{" "}
                    {(+userNodesData?.totalRewardNode3).toFixed(4)}
                  </Box>
                </TableCell>

                <TableCell>
                  <Button
                    sx={{
                      fontSize: mobile ? "12px" : "25px",
                      backgroundColor: "transparent",
                      "&:hover": {
                        background: "white",
                        color: "#FAA631",
                        border: "black",
                      },
                      color: "white",
                      borderRadius: "10px",
                      border: "solid 1px  #FAA631",
                      height: "43px",
                      paddingX: mobile ? "0px" : "20px",
                      marginX: mobile ? "0px" : "10px",
                      fontFamily: "light",
                    }}
                    onClick={() => claimHandler("2")}
                  >
                    Claim All
                  </Button>
                  <Button
                    sx={{
                      fontSize: mobile ? "12px" : "25px",
                      backgroundColor: "transparent",
                      "&:hover": {
                        background: "white",
                        color: "#FAA631",
                        border: "black",
                      },
                      color: "white",
                      borderRadius: "10px",
                      border: "solid 1px  #FAA631",
                      height: "43px",
                      paddingX: mobile ? "0px" : "20px",
                      fontFamily: "light",
                      marginTop: mobile ? "10px" : "0px",
                    }}
                    onClick={() =>{
                      
                      if(Number((+userNodesData?.totalRewardNode1).toFixed(4)) < ConValue.con3){
                        setAlertState({
                          open: true,
                          message:`You need Minimum ${ConValue.con3} CON`,
                          severity: "error",
                        });
                      }else{
                        compoundHandler("2")
                      }

                       
                      }}
                  >
                    Compound
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Divider width="100%" sx={{ background: "white", height: "1px" }} />
        </TableContainer>
      </Box>

      <Box
        mt="50px"
        className="border"
        width="100%"
        px={mobile ? "15px" : "43px"}
        py={mobile ? "20px" : "52px"}
        sx={{
          background: " rgba(248, 248, 248, 0.1)",
          backdropFilter: "blur(10px)",
          borderRadius: "20px",
          zIndex: "1",
          fontFamily: "regular",
        }}
      >
        <TableContainer>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell>
                  {" "}
                  <Box
                    sx={{
                      fontSize: mobile ? "16px" : "30px",
                      fontWeight: "400",
                      color: "#FAA631",
                      // textAlign: "center",
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        fontSize: mobile ? "16px" : "30px",
                        fontWeight: "400",
                        color: "#FAA631",
                        // textAlign: "center",
                        fontFamily: "light",
                      }}
                    >
                      {" "}
                      Creation Time
                    </Box>
                  </Box>
                </TableCell>
                <TableCell>
                  {" "}
                  <Box
                    sx={{
                      fontSize: mobile ? "16px" : "30px",
                      fontWeight: "400",
                      color: "#FAA631",
                      // textAlign: "center",
                      fontFamily: "light",
                    }}
                  >
                    Node type
                  </Box>
                </TableCell>
                <TableCell colSpan={1}>
                  {" "}
                  <Box
                    sx={{
                      fontSize: mobile ? "16px" : "30px",
                      fontWeight: "400",
                      color: "#FAA631",
                      // textAlign: "center",
                      fontFamily: "light",
                    }}
                  >
                    REWARDS
                  </Box>
                </TableCell>
                <TableCell colSpan={1}>
                  {" "}
                  <Box
                    sx={{
                      fontSize: mobile ? "16px" : "30px",
                      fontWeight: "400",
                      color: "#FAA631",
                      // textAlign: "center",
                      fontFamily: "light",
                    }}
                  >
                    Isolation Time
                  </Box>
                </TableCell>
                <TableCell colSpan={1}>
                  {" "}
                  <Box
                    sx={{
                      fontSize: mobile ? "16px" : "30px",
                      fontWeight: "400",
                      color: "#FAA631",
                      // textAlign: "center",
                      fontFamily: "light",
                    }}
                  >
                   Claim
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {userNodesData?.node1Data?.length > 0 &&
                userNodesData?.node1Data.map(
                  (
                    { name, reward, time, type, creationTime, isolationTime },
                    index
                  ) => (
                    <TableRow

                    // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <Box
                          sx={{
                            fontSize: mobile ? "12px" : "20px",
                            fontWeight: "400",
                            color: "white",
                            // textAlign: "center",
                            fontFamily: "regular",
                          }}
                        >
                          {moment.unix(creationTime).format("MM-DD-YYYY")}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            fontSize: mobile ? "12px" : "20px",
                            fontWeight: "400",
                            color: "white",
                            // textAlign: "center",
                            fontFamily: "regular",
                          }}
                        >
                          {type}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            fontSize: mobile ? "12px" : "20px",
                            fontWeight: "400",
                            color: "white",
                            // textAlign: "center",
                            fontFamily: "regular",
                          }}
                        >
                          {reward}
                        </Box>
                      </TableCell>
    

                            
                      <TableCell>
                      <Box
                          sx={{
                            fontSize: mobile ? "12px" : "20px",
                            fontWeight: "400",
                            color: "white",
                            // textAlign: "center",
                            fontFamily: "regular",
                          }}
                        >
                        <Timer  countDownDate={+isolationTime} />
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Button
                          sx={{
                            fontSize: mobile ? "10px" : "25px",
                            backgroundColor: "transparent",
                            "&:hover": {
                              background: "white",
                              color: "#FAA631",
                              border: "black",
                            },
                            color: "white",
                            borderRadius: "10px",
                            border: "solid 1px  #FAA631",
                            height: "43px",
                            paddingX: mobile ? "0px" : "20px",
                            marginLeft: mobile ? "-30px" : "0px",
                            fontFamily: "light",
                          }}
                          onClick={() => claimOneHandler(creationTime, "0")}
                        >
                          Claim
                        </Button>
                      </TableCell>
                    </TableRow>
                  )
                )}
              {userNodesData?.node2Data?.length > 0 &&
                userNodesData?.node2Data.map(
                  (
                    { name, reward, time, type, creationTime, isolationTime },
                    index
                  ) => (
                    <TableRow

                    // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <Box
                          sx={{
                            fontSize: mobile ? "12px" : "20px",
                            fontWeight: "400",
                            color: "white",
                            // textAlign: "center",
                            fontFamily: "regular",
                          }}
                        >
                          {moment.unix(creationTime).format("MM-DD-YYYY")}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            fontSize: mobile ? "12px" : "20px",
                            fontWeight: "400",
                            color: "white",
                            // textAlign: "center",
                            fontFamily: "regular",
                          }}
                        >
                          {type}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            fontSize: mobile ? "12px" : "20px",
                            fontWeight: "400",
                            color: "white",
                            // textAlign: "center",
                            fontFamily: "regular",
                          }}
                        >
                          {reward}
                        </Box>
                      </TableCell>

                      
                      <TableCell>
                      <Box
                          sx={{
                            fontSize: mobile ? "12px" : "20px",
                            fontWeight: "400",
                            color: "white",
                            // textAlign: "center",
                            fontFamily: "regular",
                          }}
                        >
                        <Timer  countDownDate={+isolationTime} />
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Button
                          sx={{
                            fontSize: mobile ? "10px" : "25px",
                            backgroundColor: "transparent",
                            "&:hover": {
                              background: "white",
                              color: "#FAA631",
                              border: "black",
                            },
                            color: "white",
                            borderRadius: "10px",
                            border: "solid 1px  #FAA631",
                            height: "43px",
                            paddingX: mobile ? "0px" : "20px",
                            marginLeft: mobile ? "-30px" : "0px",
                            fontFamily: "light",
                          }}
                          onClick={() => claimOneHandler(creationTime, "1")}
                        >
                          Claim
                        </Button>
                      </TableCell>
                    </TableRow>
                  )
                )}
              {userNodesData?.node3Data?.length > 0 &&
                userNodesData?.node3Data.map(
                  (
                    { name, reward, time, type, creationTime, isolationTime },
                    index
                  ) => (
                    <TableRow

                    // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <Box
                          sx={{
                            fontSize: mobile ? "12px" : "20px",
                            fontWeight: "400",
                            color: "white",
                            // textAlign: "center",
                            fontFamily: "regular",
                          }}
                        >
                          {moment.unix(creationTime).format("MM-DD-YYYY")}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            fontSize: mobile ? "12px" : "20px",
                            fontWeight: "400",
                            color: "white",
                            // textAlign: "center",
                            fontFamily: "regular",
                          }}
                        >
                          {type}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            fontSize: mobile ? "12px" : "20px",
                            fontWeight: "400",
                            color: "white",
                            // textAlign: "center",
                            fontFamily: "regular",
                          }}
                        >
                          {reward}
                        </Box>
                      </TableCell>

                      
                      <TableCell>
                      <Box
                          sx={{
                            fontSize: mobile ? "12px" : "20px",
                            fontWeight: "400",
                            color: "white",
                            // textAlign: "center",
                            fontFamily: "regular",
                          }}
                        >
                        <Timer  countDownDate={+isolationTime} />
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Button
                          sx={{
                            fontSize: mobile ? "10px" : "25px",
                            backgroundColor: "transparent",
                            "&:hover": {
                              background: "white",
                              color: "#FAA631",
                              border: "black",
                            },
                            color: "white",
                            borderRadius: "10px",
                            border: "solid 1px  #FAA631",
                            height: "43px",
                            paddingX: mobile ? "0px" : "20px",
                            marginLeft: mobile ? "-30px" : "0px",
                            fontFamily: "light",
                          }}
                          onClick={() => claimOneHandler(creationTime, "2")}
                        >
                          Claim
                        </Button>
                      </TableCell>
                    </TableRow>
                  )
                )}
              {userNodesData?.node1Data?.length === 0 &&
                userNodesData?.node2Data?.length === 0 &&
                userNodesData?.node3Data?.length === 0 && (
                  <TableRow>
                    <TableCell component="th" scope="row" colSpan={5}>
                      <Box
                        sx={{
                          fontSize: mobile ? "12px" : "20px",
                          fontWeight: "400",
                          color: "white",
                          // textAlign: "center",
                          fontFamily: "regular",
                          textAlign: "center",
                        }}
                      >
                        NO NODE FOUND
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
            </TableBody>
          </Table>

          <Divider width="100%" sx={{ background: "white", height: "1px" }} />
        </TableContainer>
      </Box>
    </>
  );
}

export default Overview;
